import { Heading, Text } from '@uhg-harmony/react';
import type { Announcement } from '@/types';
import { SafeHtml } from '@/utils/SafeHtml';
import styles from './ProgramAnnouncementsSection.module.css';

interface ProgramAnnouncementsSectionProps {
  heading: string;
  announcements: Announcement[];
}

export function ProgramAnnouncementsSection({ heading, announcements }: ProgramAnnouncementsSectionProps) {
  return (
    <section className={styles.section} tabIndex={0}>
      <div className={styles.box}>
        <Heading level="h2" className={styles.heading}>{heading}</Heading>
        <div className={styles.itemList}>
          {announcements.map((a) => (
            <div key={a.announcementId} className={styles.item}>
              <Text as="p" className={styles.title}>{a.title}</Text>
              {a.content && (
                <SafeHtml html={a.content} className={styles.body} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
